import React from 'react';

import { FormField, FormHelp, Label } from '@zillow/constellation';

import type { Section } from '../../../../models/index';
import { HOA_RULES } from '../../../../constants';
import YesAndNo from '../../../Widgets/YesAndNo';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function HoaRules({ section, setSectionValues }: Props) {
  function onNoRules(): void {
    setSectionValues({
      [HOA_RULES.FIELD_NAME.IS_ENABLED]: false,
    });
  }

  function onYesRules(): void {
    setSectionValues({
      [HOA_RULES.FIELD_NAME.IS_ENABLED]: true,
    });
  }

  const HOARulesActive = section.getFieldValue(HOA_RULES.FIELD_NAME.IS_ENABLED);

  return (
    <FormField
      label={<Label size="lg">Do any homeowners association rules apply to the property?</Label>}
      control={<YesAndNo yesHandler={onYesRules} noHandler={onNoRules} yesActive={HOARulesActive} />}
      description={
        HOARulesActive && (
          <FormHelp>
            You must provide the tenant copies of all homeowners association rules and regulations before the lease is
            signed
          </FormHelp>
        )
      }
    />
  );
}

HoaRules.description = 'Separate HOA rules screen to track HOA specific rules (separate from condo association rules)';

export default HoaRules;
